import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { T as Tooltip } from './chunk-2229e354.js';
export { T as BTooltip } from './chunk-2229e354.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Tooltip);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/tooltip.js
// module id = +wWI
// module chunks = 0 1